<div class="col-md-12 mb-30" *ngIf="Selected_Salary_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Payroll List</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Full Name</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Year </label>
          <select [(ngModel)]="Filter_year" (change)="ReadData_Salary()" class="custom-select">
            <option value="1403">Year 1403</option>
            <option value="1404">Year 1404</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Salary()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>
          <button *ngIf="!Procssing" (click)="Set_Form_Salary_View_Add()" type="button" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Set Annual Payroll </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Full Name</th>
              <th>Membership Allowance</th>
              <th>Employee Allowance</th>
              <th>Job Allowance</th>
              <th colspan="2">Performance</th>
              <th colspan="2">Grand Total</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DataList_Salary
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Salary|filter:Filter_title:'fullname').length
                      }
            ">

              <tr>
                <td rowspan="2">{{DataList_Salary.indexOf(item)+1}}</td>
                
                <td>{{item.fullname}}</td>
                <td>{{item.partnership|number}}</td>
                <td>{{item.person|number}} </td>
                <td>{{item.position|number}} </td>
                <td colspan="2">{{item.performance|number}} </td>
                <td colspan="2">{{item.salary|number}} </td>

                <td rowspan="2">
                  <button (click)="Set_Form_Salary_View_Add2(item.personId,item.fullname)" type="button"
                    class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Edit
                  </button>
                </td>

              </tr>

              <tr>
                <th>Employee Coefficient</th>
                <td>{{item.person_rate|number}} </td>

                <th>Job Coefficient</th>
                <td>{{item.position_rate|number}} </td>

                <th>Overtime Hours</th>
                <td>{{item.ezakekarHour|number}} </td>

                <th>Mission</th>
                <td>{{item.missionHour|number}} </td>

              </tr>

            </ng-container>


          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<div class="col-md-12 mb-30" *ngIf="Selected_Salary_Record_Switcher=='BaseForm'">
  <app-SalaryBaseForm [inner_Year]="Selected_Salary_Year" (outter_Salary)="Set_List_Salary_View($event)">
  </app-SalaryBaseForm>
</div>



<div class="col-md-12 mb-30" *ngIf="Selected_Salary_Record_Switcher=='PersonForm'">
  <app-SalaryPersonForm [inner_Year]="Selected_Salary_Year" [inner_PersonId]="Selected_Salary_PersonId"
    [inner_Person_Fullname]="Selected_Salary_Person_Fullname" (outter_Salary)="Set_List_Salary_View($event)">
  </app-SalaryPersonForm>
</div>